<template>
	<div>
		<div class="content-header">
            <ol class="breadcrumb">
                <li class="active">物流配置</li>
            </ol>
        </div>
        <div class="content-operator content-border">
            <el-button type="primary" size="small" @click="$common.goRouterLink({ name: 'freightDetail' })">添加配置</el-button>
        </div>
        <div class="content-query content-border">
            <el-form :inline="true" :model="query" class="demo-form-inline">
                <el-form-item label="模板名称：">
                    <el-input v-model="query.name"></el-input>
                </el-form-item>
                <!-- <el-form-item label="快递公司：">
                    <el-input v-model="query.company"></el-input>
                </el-form-item> -->
                <el-form-item label="是否默认：">
                    <el-select v-model="query.isdefault" clearable>
                        <el-option v-for="item in isDefaultOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="　关键词：">
                    <el-input v-model="query.keyWord"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" icon="el-icon-search" @click="submitQuery(1)">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="title">
            <label>物流列表</label>
        </div>
        <el-alert
            title="温馨提示"
            type="info"
            description="查看具体的物流地区列表请点击--物流列表--中的数据！"
            show-icon>
        </el-alert>
		<div class="content-data" v-if="freightItems && 0 < freightItems.length">
            <el-table :data="freightItems" style="width: 100%">
                <el-table-column label="序号" type="index"/>
                <el-table-column label="物流模板名称" prop="name"/>
                <el-table-column label="是否为默认物流">
                    <template slot-scope="scope">
                        <span>{{scope.row.isdefault === 1?'是':'否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" round @click="updatedefaultSet(scope.row.id)" v-if="scope.row.isdefault === 0">设为默认</el-button>
                        <el-button type="primary" size="mini" round @click="$common.goRouterLink({ name: 'freightDetail',query: { freightId:scope.row.id } })">修改</el-button>
                        <el-button type="danger" size="mini" round @click="deleteFreightConfirm(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <vue-pager v-bind:datafile="fillData" url="freightConfig/pageFreightConfig" v-bind:query="query" ref="pager" v-bind:init="true"></vue-pager>
        <hr/>
	</div>
</template>
<script>
export default {
	data() {
		return { 
			freightItems:[],
            freightZoneItems:[],
			query:{
                name:'',
                company:'',
                isdefault:'',
                keyWord:'',
                userId:'',
            },
            userId:'',
            freightZoneQuery:{},
            isDefaultOptions:[
                {
                    value:1,
                    label:'是'
                },
                {
                    value:0,
                    label:'否'
                }
            ],
            deleteModel: {
               freightId:''
            }
		};
	},
    created() {
            var _this = this;
             _this.userInfo=_this.$common.cache('user_info');
             _this.userId=_this.userInfo.userId;
             _this.query.userId=_this.userInfo.userId;
    },
	methods:{
		updatedefaultSet(_id){
			var _this = this;
            _this.$common.my_ajax({
                url: 'freightConfig/updateFreightDefault',
                data: {
                    freightConfigId:_id
                },
                success: function(response) {
                    _this.$message({
                        type: 'success',
                        message: '操作成功'
                    });
                    _this.submitQuery(1);
                }
            });
		},
		fillData(_response) {
            var _this = this;
            _this.freightItems = _response.items;
            if (_this.freightItems && _this.freightItems.length==0) {
                _this.freightZoneItems = [];
            }
            // if (_this.freightItems.length > 0) {
            //     _this.$set(_this.query, 'freightConfig', _this.freightItems[0].id);
            //     _this.submitfillSonTable(1);
            // }
        },
        fillSonTableData(_response) {
            var _this = this;
            _this.freightZoneItems = [];
            _this.freightZoneItems = _response.items;
        },
        submitQuery(_num) {
            var _this = this;
            _this.freightItems = [];
            _this.$refs.pager.gotoPage(_num);
        },
        submitfillSonTable(_num) {
            var _this = this;
            _this.freightZoneItems = [];
            _this.$refs.pageFreightZoneConfig.gotoPage(_num);
        },
        showSonTable(_freightConfig){
            var _this = this;
            _this.query.freightConfig=_freightConfig;
            _this.submitfillSonTable(1);
        },
        deleteFreightConfirm(_freightId) {
            var _this = this;
            _this.deleteModel.freightId = _freightId;
            _this.$confirm('此操作将永久删除该数据，相关的物流地区配置数据也会删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
            _this.$common.my_ajax({
                url: 'freightConfig/deleteFreightConfig',
                data: {
                    freightId:_freightId
                },
                success: function(response) {
                    _this.freightItems = [];
                    _this.$refs.pager.gotoPage(1);
                }
            });
                _this.$message({
                    type: 'success',
                    message: '删除成功'
                });
            }).catch(() => {
                _this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        }
	}
}
</script>
<style scoped>
 #border {
    height: 110px;
    width: 1100px;
    color: silver;
    border-style: solid;
}
.title{
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
    margin-top: 10px;
    margin-bottom: 10px;
}

.title span{
    margin-bottom: 5px;
}

th {
    background-color: #1E90FF;
    text-align: center;
    font-weight: bolder;
    color: white;
}
td{
    text-align:center;
}
.tr-1 td {
    text-align: center;
    line-height: 40px !important;
}

.tr-1 td:first-child{
    text-align: center;
    font-size: 18px;
    font-weight:bold;
    color: #101010;
}
</style>
